import React from 'react';
import '../../../../sass/apps/commerce/desktop/total.scss';

const callToAction = (promoCode, localisations) =>
  promoCode ? localisations.promo_code : localisations.early_renewal;

const calculateDiscount = (percentage, price, currencySymbol) => {
  const discountAmount = (price * percentage) / 100;
  return `-${currencySymbol}${discountAmount.toFixed(2)}`;
};

function Total({ discounts, subTotal, total, currencySymbol, localisations }) {
  return (
    <div className="checkout-total">
      {discounts.percentage ? (
        <div className="checkout-total__discount">
          <span className="checkout-total__discount-description">
            {callToAction(discounts.promo_code, localisations)}{' '}
            {discounts.percentage}% {localisations.off}
          </span>
          <span className="checkout-total__discount-amount">
            {calculateDiscount(discounts.percentage, subTotal, currencySymbol)}
          </span>
        </div>
      ) : null}
      <div className="checkout-total__total">
        <span className="checkout-total__total-description">Total</span>
        <span className="checkout-total__total-amount">
          {currencySymbol}
          {total}
        </span>
      </div>
    </div>
  );
}

export default Total;
